import PhoneNumberImput from './../phone-number-input/component.vue';
import { mapActions } from 'vuex';
import { hValidatePhoneNumber } from '@/utils/helpers';

export default {
  name: 'page-welcome',
  props: ['widgetStyle', 'widgetConfig', 'isHotlineAvailable'],
  components: {
    'phone-number-input': PhoneNumberImput,
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
        borderColor: this.widgetStyle.main_color,
      };
    },
  },
  methods: {
    ...mapActions(['makeCall', 'callLater', 'toggleWidgetModal', 'showErrorMessage', 'hideErrorMessage']),
    __callHandler(number) {
      this.makeCall(number);
      
      //if (this.isHotlineAvailable) {

      // } else {
      //   this.callLater({ destNumber: number });
      // }
    },
    callNow() {
      const { phoneNumber } = this.$children[0]; // HACK: pobranie numeru z komponentu dziecka - paskudne rozwiązanie :(
      this.hideErrorMessage();
      hValidatePhoneNumber(phoneNumber)
        .then(number => this.__callHandler(number))
        .catch(() => {
          this.showErrorMessage('Wprowadzony numer telefonu jest nieprawidłowy');
        });
    },
  },
};
